export const DOC_TYPE_LABELS: Record<
  string,
  { label: string; color: string }
> = {
  vehicle_gatepass:   { label: "Vehicle Gate Pass",   color: "geekblue" },
  weightment_slip:    { label: "Weightment Slip",      color: "gold" },
  final_weightment:   { label: "Final Weightment",     color: "blue" },
  surveyor_seal:      { label: "Surveyor Seal",        color: "volcano" },
  driver_arrival:     { label: "Driver Arrival",       color: "cyan" },
  challan_slip:       { label: "Challan Slip",         color: "green" },
  truck_sheet:        { label: "Truck Sheet",          color: "orange" },
  form_515:           { label: "Form 515",             color: "purple" },
  wharfage_demurrage: { label: "Wharfage / Demurrage", color: "magenta" },
};

const formatDocTypeLabel = (docType: string) =>
  docType
    .split("_")
    .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
    .join(" ");

export const getDocTypeConfig = (docType: string) =>
  DOC_TYPE_LABELS[docType] || { label: formatDocTypeLabel(docType), color: "default" };

export const isPdfUrl = (url?: string) =>
  !!url && url.toLowerCase().includes(".pdf");
